import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Form, Input, Button, message} from "antd";
import {Row, Col, Alert} from "antd";
import {useTranslation} from "react-i18next";
import {authActions} from "_actions";
import Logo from "components/Logo/Logo.js";
import variables from "_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import {history} from "_helpers/history";

import {PasswordInput} from "antd-password-input-strength";
const storage = localOrSessionStore({key: variables.REMEMBER});

function TutorResetPasswordPage(props) {
  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const user = storage.getItem(variables.USER);
  const [level, setLevel] = useState(0);
  const [email, setEmail] = useState(false);
  const minLevel = 0;
  const errorMessage = t("cuenta.debil");
  const [showPasswordChanged, setShowPasswordChanged] = useState(false);
  var resetPassword = useSelector((state) => state.authReducer.reset);
  var errorResetPassword = useSelector((state) => state.authReducer.reset);
  const onFinish = (values) => {
    setLoading(true);
    dispatch(authActions.resetPassword(email, values.password, values.confirm));
  };

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setEmail(JSON.parse(user).email);
    } else {
      history.push("/auth/login");
    }
  }, [user]);
  useEffect(() => {
    if (resetPassword !== undefined) {
      setShowPasswordChanged(true);
      message.success(t("login.passwordc"));
      //   history.push("/admin/dashboard")
    }
    // Actualiza el título del documento usando la API del navegador
  }, [resetPassword]);

  return (
    <>
      {email && (
        <Row justify="space-around" align="middle">
          <Col className="resetPassword">
            <div style={{textAlign: "center"}}>
              <div className="logoh">
                <Logo menu={false} />
              </div>
            </div>
            <Form
              name="password-reset"
              className="login-form"
              initialValues={{
                remember: false,
              }}
              onFinish={onFinish}
            >
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: t("login.passwordMandatory"),
                  },
                  {
                    validator: async () => {
                      return level >= minLevel ? Promise.resolve() : Promise.reject(errorMessage);
                    },
                    message: errorMessage,
                  },
                ]}
                hasFeedback
              >
                <PasswordInput
                  onLevelChange={setLevel}
                  settings={{
                    height: 7,
                    alwaysVisible: true,
                    colorScheme: {
                      levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
                      noLevel: "lightgrey",
                    },
                  }}
                />
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="confirm"
                label="Confirm Password"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: t("login.passwordMandatory"),
                  },
                  ({getFieldValue}) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t("login.passwordmis")));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Button type="primary" loading={loading} htmlType="submit" className="login-form-button">
                  {t("login.reset")}
                </Button>
                {error && <Alert message={errorMsg} type="error" />}
              </Form.Item>
            </Form>
          </Col>
        </Row>
      )}
    </>
  );
}
export default withTranslation()(TutorResetPasswordPage);
